export enum NavTypes{
    Tutorial = "Tutorial",
    NotCompleted = "NotCompleted",
    Completed = "Completed"
}